export default __webpack_public_path__ + "static/media/27_TopLeftSquares_ZoomOut.6eab2fe7.mp4";